/* Evoke – colour swatches on product cards.
   Each .xo-sw has data-name (colour name) and, when a photo with that alt text exists, data-sample (small photo).
   The circle is coloured from the photo: the garment colour that best matches the colour name.
   Two-tone names ("Navy/White") become a diagonal split; if the second colour can't be found
   the circle shows the main body colour. Results are cached in the browser. */
(function () {
  'use strict';

  var CACHE = 'xosw3:';

  /* rough colours for common names – guide which part of the photo to sample, and the fallback */
  var NAMES = [
    ['hi vis yellow', '#e4f000'], ['fluoro yellow', '#e4f000'], ['fluro yellow', '#e4f000'], ['hi vis orange', '#ff6a13'],
    ['fluoro orange', '#ff6a13'], ['fluro orange', '#ff6a13'], ['fluoro pink', '#ff4fa3'], ['fluoro green', '#7cff3a'],
    ['bottle green', '#0b4d2c'], ['bottle', '#0b4d2c'], ['forest', '#1f4a2c'], ['forest green', '#1f4a2c'], ['kelly green', '#2d9b3a'], ['emerald', '#0f8a4e'],
    ['royal blue', '#1f47a8'], ['sky blue', '#8ec5ea'], ['light blue', '#a7cfee'], ['baby blue', '#a7cfee'],
    ['powder blue', '#b9d4ea'], ['cornflower', '#6a8fd6'], ['french navy', '#1d2a4d'], ['ink navy', '#1a2133'],
    ['hot pink', '#e2348c'], ['light pink', '#f5c6d6'], ['baby pink', '#f5c6d6'], ['dusty pink', '#d8a5a8'],
    ['charcoal', '#3b3d40'], ['graphite', '#45484c'], ['gunmetal', '#4a4d52'], ['slate', '#5e6772'],
    ['steel', '#71808e'], ['silver', '#bfc3c7'], ['ash', '#c9c9c4'], ['marle', '#a5a7a8'], ['heather', '#a5a7a8'],
    ['grey', '#8e9195'], ['gray', '#8e9195'], ['black', '#1b1b1d'], ['jet', '#1b1b1d'],
    ['white', '#ffffff'], ['snow', '#fafafa'], ['natural', '#efe6d2'], ['ivory', '#f4eedc'], ['cream', '#f1e7cf'],
    ['navy', '#1d2540'], ['midnight', '#1d2540'], ['royal', '#1f47a8'], ['cobalt', '#1f4fbf'], ['denim', '#4a6a8f'],
    ['petrol', '#1d5a6b'], ['teal', '#127a7a'], ['aqua', '#36b8c4'], ['turquoise', '#2fb7c2'], ['cyan', '#2fb7d8'],
    ['skyblue', '#8ec5ea'], ['electric blue', '#1f6fe0'], ['sky', '#8ec5ea'], ['blue', '#2c5aa8'],
    ['maroon', '#5e1a24'], ['burgundy', '#5c1a2b'], ['wine', '#5a1b2c'], ['cardinal', '#a01c2c'], ['scarlet', '#c0182a'],
    ['red', '#c62230'], ['coral', '#f26b5b'], ['salmon', '#f09a86'], ['rust', '#a64b24'], ['burnt orange', '#c45a1f'],
    ['orange', '#f0702a'], ['tangerine', '#f58a2a'], ['gold', '#e8a91b'], ['mustard', '#d3a12a'], ['amber', '#e8a01b'],
    ['lemon', '#f5e463'], ['yellow', '#f4d21f'],
    ['lime', '#9ad13b'], ['mint', '#9fdcc0'], ['sage', '#9caf88'], ['olive', '#5b5e2e'], ['army', '#4b5320'],
    ['khaki', '#a8986b'], ['military', '#4b5320'], ['green', '#2b8a3e'],
    ['purple', '#5b2a86'], ['grape', '#5a2d6e'], ['violet', '#6a3d9a'], ['plum', '#5d2a4a'], ['lavender', '#b9a6d8'], ['lilac', '#c3a6d6'],
    ['magenta', '#c3247e'], ['fuchsia', '#c3247e'], ['pink', '#ef8fb5'],
    ['stone', '#c7b99c'], ['sand', '#d2bf96'], ['beige', '#d8c7a6'], ['oatmeal', '#d7cbb3'], ['taupe', '#8f8274'],
    ['tan', '#b88a5a'], ['camel', '#b88a5a'], ['chocolate', '#4a2f22'], ['coffee', '#5a3d2b'], ['brown', '#6b4630']
  ];

  /* longest names first ("sky blue" before "blue"); marle/heather only describe texture, so they go last */
  NAMES.sort(function (a, b) {
    var ta = /marle|heather/.test(a[0]) ? 1 : 0, tb = /marle|heather/.test(b[0]) ? 1 : 0;
    return ta - tb || b[0].length - a[0].length;
  });

  function hex(h) { h = h.replace('#', ''); return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)]; }
  function css(c) { return 'rgb(' + c.map(Math.round).join(',') + ')'; }
  function sat(c) { var mx = Math.max(c[0], c[1], c[2]), mn = Math.min(c[0], c[1], c[2]); return mx < 20 ? 0 : (mx - mn) / mx; }
  function lum(c) { return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) / 255; }
  /* "redmean" colour distance – cheap and closer to how eyes see it than plain RGB */
  function dist(a, b) {
    var rm = (a[0] + b[0]) / 2, dr = a[0] - b[0], dg = a[1] - b[1], db = a[2] - b[2];
    return Math.sqrt((2 + rm / 256) * dr * dr + 4 * dg * dg + (2 + (255 - rm) / 256) * db * db) / 3;
  }

  function hint(part) {
    var p = ' ' + part.toLowerCase().replace(/[^a-z ]+/g, ' ').replace(/\s+/g, ' ') + ' ';
    for (var i = 0; i < NAMES.length; i++) {
      if (p.indexOf(' ' + NAMES[i][0] + ' ') >= 0) return hex(NAMES[i][1]);
    }
    return null;
  }

  /* garment colour clusters from a photo, biggest first */
  function clusters(img) {
    var W = Math.min(100, img.naturalWidth || 100), H = Math.max(1, Math.round(W * img.naturalHeight / img.naturalWidth));
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var cx = cv.getContext('2d');
    cx.drawImage(img, 0, 0, W, H);
    var d = cx.getImageData(0, 0, W, H).data;
    function px(x, y) { var i = (y * W + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; }

    /* background = corners */
    var bgs = [px(1, 1), px(W - 2, 1), px(1, H - 2), px(W - 2, H - 2)].filter(function (p) { return p[3] > 200; });
    var bg = bgs.length ? [0, 1, 2].map(function (k) { return bgs.reduce(function (s, p) { return s + p[k]; }, 0) / bgs.length; }) : [255, 255, 255];

    var buckets = {}, fg = 0;
    var x0 = Math.floor(W * 0.08), x1 = Math.ceil(W * 0.92), y0 = Math.floor(H * 0.05), y1 = Math.ceil(H * 0.97);
    for (var y = y0; y < y1; y++) for (var x = x0; x < x1; x++) {
      var p = px(x, y);
      if (p[3] < 200 || dist(p, bg) < 22) continue;
      fg++;
      var k = (p[0] >> 5) + ',' + (p[1] >> 5) + ',' + (p[2] >> 5);
      var b = buckets[k] || (buckets[k] = { n: 0, s: [0, 0, 0] });
      b.n++; b.s[0] += p[0]; b.s[1] += p[1]; b.s[2] += p[2];
    }
    var list = Object.keys(buckets).map(function (k) { var b = buckets[k]; return { n: b.n, s: b.s, c: b.s.map(function (v) { return v / b.n; }) }; })
      .sort(function (a, b) { return b.n - a.n; });

    /* merge similar shades (light and shadow of the same fabric) */
    var out = [];
    list.forEach(function (b) {
      var best = null, bd = 1e9;
      out.forEach(function (o) { var dd = dist(o.seed, b.c); if (dd < bd) { bd = dd; best = o; } });
      if (best && bd < 34) { best.n += b.n; for (var i = 0; i < 3; i++) best.s[i] += b.s[i]; }
      else out.push({ seed: b.c, n: b.n, s: b.s.slice() });
    });
    out.forEach(function (o) { o.c = o.s.map(function (v) { return v / o.n; }); o.share = fg ? o.n / fg : 0; });
    out.sort(function (a, b) { return b.n - a.n; });
    return { list: out, bg: bg, fg: fg / ((x1 - x0) * (y1 - y0)) };
  }

  /* pick the cluster for one colour name */
  function pick(cl, h, minShare, skip) {
    var cands = cl.list.filter(function (o) { return o.share >= minShare && skip.indexOf(o) < 0; });
    if (!cands.length) return null;
    if (!h) return cands[0];
    var best = null, bs = -1;
    cands.forEach(function (o) {
      var dd = dist(o.c, h);
      if (dd > 95) return;
      /* a grey can't stand in for a strong colour (teal, red…), and a strong colour can't stand in for black/grey/white */
      if (sat(h) > 0.3 && sat(o.c) < 0.25) return;
      if (sat(h) < 0.15 && sat(o.c) > 0.4) return;
      var score = o.share * (1 - dd / 110);
      if (score > bs) { bs = score; best = o; }
    });
    return best;
  }

  /* returns "rgb(..)" or "rgb(..)|rgb(..)" */
  function colourFor(name, img) {
    var parts = name.split('/').map(function (s) { return s.trim(); }).filter(Boolean);
    var hA = hint(parts[0] || name), hB = parts.length > 1 ? hint(parts[1]) : null;
    var cl;
    try { cl = clusters(img); } catch (e) { return null; }

    function one(h, minShare, skip, isMain) {
      if (h && lum(h) > 0.9) {
        /* white / natural on a white backdrop: trust a light cluster if there is one, otherwise the name */
        var light = cl.list.filter(function (o) { return skip.indexOf(o) < 0 && o.share >= 0.04 && lum(o.c) > 0.78 && dist(o.c, h) < 60; })[0];
        return light || { c: h, named: true };
      }
      var o = pick(cl, h, minShare, skip);
      if (!o && isMain) o = h ? { c: h, named: true } : cl.list[0] || null;
      return o;
    }

    var A = one(hA, 0.06, [], true);
    if (!A) return null;
    if (parts.length < 2 || parts[0].toLowerCase() === parts[1].toLowerCase()) return css(A.c);   /* "Black/Black" is one colour */
    /* the second colour is often just trim or side panels, so a small share is enough when the name guides it */
    var B = one(hB, hB ? 0.008 : 0.03, A.named ? [] : [A], false);
    if (!B || dist(A.c, B.c) < 30) return css(A.c);   /* fallback: main body colour */
    return css(A.c) + '|' + css(B.c);
  }

  function paint(sw, val) {
    var span = sw.firstChild && sw.firstChild.nodeType === 1 ? sw.firstChild : sw.querySelector('span');
    if (!span || !val) return;
    var cs = val.split('|');
    span.style.background = cs.length > 1 ? 'linear-gradient(135deg, ' + cs[0] + ' 50%, ' + cs[1] + ' 50%)' : cs[0];
    var light = cs.some(function (c) { var m = c.match(/\d+/g); return m && lum(m.map(Number)) > 0.86; });
    sw.classList.toggle('xo-sw-light', light);
    sw.classList.add('xo-sw-done');
  }

  function cacheGet(k) { try { return window.localStorage.getItem(CACHE + k); } catch (e) { return null; } }
  function cacheSet(k, v) { try { window.localStorage.setItem(CACHE + k, v); } catch (e) { } }

  /* name-only colour while the photo loads (or when there's no photo) */
  function guess(name) {
    var parts = name.split('/'), a = hint(parts[0]), b = parts.length > 1 ? hint(parts[1]) : null;
    if (!a) return 'rgb(221,221,221)';
    return css(a) + (b ? '|' + css(b) : '');
  }

  var queue = [], busy = 0;
  function next() {
    while (busy < 3 && queue.length) {
      (function (sw) {
        busy++;
        var src = sw.getAttribute('data-sample'), name = sw.getAttribute('data-name') || '';
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          var v = colourFor(name, img);
          if (v) { paint(sw, v); cacheSet(src + '#' + name, v); }
          busy--; next();
        };
        img.onerror = function () { busy--; next(); };
        img.src = src;
      })(queue.shift());
    }
  }

  var started = (typeof WeakSet === 'function') ? new WeakSet() : null;
  function startRow(row) {
    if (started) { if (started.has(row)) return; started.add(row); }
    else { if (row.xoStarted) return; row.xoStarted = true; }
    var sws = row.querySelectorAll('.xo-sw');
    for (var i = 0; i < sws.length; i++) {
      var sw = sws[i], name = sw.getAttribute('data-name') || '', src = sw.getAttribute('data-sample');
      var cached = src ? cacheGet(src + '#' + name) : null;
      if (cached) { paint(sw, cached); continue; }
      paint(sw, guess(name));
      sw.classList.remove('xo-sw-done');
      if (src) queue.push(sw);
    }
    next();
  }

  /* keep the swatches on one neat row: hide what doesn't fit and show "+N" */
  function fitRow(box) {
    var row = box.querySelector('.xo-sw-row');
    if (!row || !row.clientWidth) return;
    var sws = row.querySelectorAll('.xo-sw'), total = parseInt(box.getAttribute('data-count'), 10) || sws.length;
    var more = row.querySelector('.xo-sw-more');
    if (!more) { more = document.createElement('a'); more.className = 'xo-sw-more'; more.href = box.getAttribute('data-url') || '#'; row.appendChild(more); }
    for (var i = 0; i < sws.length; i++) sws[i].style.display = '';
    var w = row.clientWidth, step = (sws[0] ? sws[0].offsetWidth : 22) + 7, fits = Math.max(1, Math.floor((w + 7) / step));
    var show = total > fits ? Math.max(1, Math.floor((w + 7 - 34) / step)) : total;
    show = Math.min(show, sws.length);
    for (i = show; i < sws.length; i++) sws[i].style.display = 'none';
    var hidden = total - show;
    more.textContent = hidden > 0 ? '+' + hidden : '';
    more.style.display = hidden > 0 ? '' : 'none';
  }
  function fitAll() { var b = document.querySelectorAll('.xo-swatches'); for (var i = 0; i < b.length; i++) fitRow(b[i]); }
  var fitTimer;
  window.addEventListener('resize', function () { clearTimeout(fitTimer); fitTimer = setTimeout(fitAll, 150); });

  /* hover: swap the card photo and show the colour name */
  function cardImg(row) {
    var box = row.closest('.main_box') || row.parentNode;
    return box ? box.querySelector('.product-image img, .list-image img') : null;
  }
  var bound = (typeof WeakSet === 'function') ? new WeakSet() : null;
  function bindRow(row) {
    /* a WeakSet, not an attribute: carousels (home page) clone cards, and clones need their own listeners */
    if (bound) { if (bound.has(row)) return; bound.add(row); }
    else { if (row.xoBound) return; row.xoBound = true; }
    var count = row.querySelector('.xo-sw-count'), countText = count ? count.textContent : '';
    var img = cardImg(row), orig = img ? img.getAttribute('src') : null;
    row.addEventListener('mouseover', function (e) {
      var sw = e.target.closest ? e.target.closest('.xo-sw') : null;
      if (!sw) return;
      if (count) count.textContent = sw.getAttribute('data-name');
      var to = sw.getAttribute('data-img');
      if (img && to) { img.removeAttribute('srcset'); img.setAttribute('src', to); }
    });
    row.addEventListener('mouseleave', function () {
      if (count) count.textContent = countText;
      if (img && orig) img.setAttribute('src', orig);
    });
  }

  /* refit whenever a row changes width (carousels lay out after page load, window resizes, etc.) */
  var ro = ('ResizeObserver' in window) ? new ResizeObserver(function (es) {
    es.forEach(function (e) { var box = e.target.closest('.xo-swatches'); if (box) fitRow(box); });
  }) : null;
  var watched = (typeof WeakSet === 'function') ? new WeakSet() : null;

  function init(root) {
    var rows = (root || document).querySelectorAll('.xo-swatches');
    if (!rows.length) return;
    if (ro) for (var j = 0; j < rows.length; j++) {
      var r = rows[j].querySelector('.xo-sw-row');
      if (r && (!watched || !watched.has(r))) { if (watched) watched.add(r); ro.observe(r); }
    }
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); startRow(e.target); } });
    }, { rootMargin: '200px' }) : null;
    for (var i = 0; i < rows.length; i++) {
      fitRow(rows[i]);
      bindRow(rows[i]);
      if (io) io.observe(rows[i]); else startRow(rows[i]);
    }
  }

  window.xoSwatches = { init: init, colourFor: colourFor, hint: hint };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* again once images/carousels have finished setting up */
  window.addEventListener('load', function () { init(); setTimeout(function () { init(); fitAll(); }, 800); });
  /* cards added later (infinite scroll, quick view, related products) */
  if (window.jQuery) jQuery(document).ajaxComplete(function () { setTimeout(init, 50); });
})();
